import { useState, useEffect } from 'react';
import { usePlatform } from './usePlatform';
import { isStandalone } from '../lib/platform';

/**
 * True when the user should see the native/PWA app chrome (bottom nav, mobile header,
 * mobile-app-container). Only Capacitor native or an installed PWA — not the mobile browser.
 */
export function useMobileAppShell(): boolean {
  const { isNative } = usePlatform();
  const [standalone, setStandalone] = useState(() =>
    typeof window !== 'undefined' ? isStandalone() : false
  );

  useEffect(() => {
    const sync = () => setStandalone(isStandalone());
    const mql = window.matchMedia('(display-mode: standalone)');
    mql.addEventListener('change', sync);
    return () => mql.removeEventListener('change', sync);
  }, []);

  return isNative || standalone;
}

/**
 * Viewport-based small screen (Tailwind md breakpoint). Use for spacing/typography that
 * should follow narrow width in any context, including mobile Safari/Chrome.
 */
export function useIsNarrowViewport(): boolean {
  const [narrow, setNarrow] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(max-width: 767px)').matches : false
  );

  useEffect(() => {
    const mql = window.matchMedia('(max-width: 767px)');
    const handler = (e: MediaQueryListEvent) => setNarrow(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return narrow;
}
